import Vue from "vue";
import Vuex from "vuex";
import axios from "axios"
import jwt_decode from 'jwt-decode'
import router from "@/router";
import {mapGetters} from 'vuex'

Vue.use(Vuex);

const url = "https://www.cava.wine"

export const store = new Vuex.Store({
    state: {
        fileItems:
            [
                {title: 'Memoria de actividades', id: 1},
                {title: 'Imagenes', id: 2},
                {title: 'Logotipos D.O. Cava', id: 3},
                {title: 'Presentaciones / Estadísticas', id: 4}
            ],
        content: '',
        color: '',
        hash: '',

        lang: localStorage.getItem('lang'),
        jwt: localStorage.getItem('token'),
        usergroup: localStorage.getItem('usergroup'),
        userid: localStorage.getItem('userid'),
        username: localStorage.getItem('username'),
        bodega: localStorage.getItem('bodega'),
        baseurl:url,
        endpoints: {
            obtainJWT: url+'/api/token/',
            refreshJWT: url+'/api/token/refresh/',
            getUser: url+'/api/usergroup/',
            newpassword: url+'/api/newpassword/',
            oknewpassword: url+'/api/oknewpassword/',
            memoria: url+'/api/v1/memoria/',
            simpleupload: url+'/api/upload-file/',
            evento: url+'/api/v1/evento/',
            participacion: url+'/api/v1/participacion/',
            bodega: url+'/api/v1/bodega/',
            bodegas: url+'/api/v1/bodega/',
            updateaccount: url+'/api/v1/update-account/'

        }
    },
    mutations: {
        showMessage(state, payload) {
            state.content = payload.content
            state.color = payload.color
            state.hash = Math.random()
        },
        updateToken(state, newToken) {
            localStorage.setItem('token', newToken);
            state.jwt = newToken;
        },
        removeToken(state) {
            console.log("Remove token")
            localStorage.removeItem('token');
            localStorage.removeItem('usergroup');
            localStorage.removeItem('userid');
            localStorage.removeItem('username');
            localStorage.removeItem('bodega');
            state.jwt = null
            state.usergroup = null
            state.userid = null
            state.username = null
            state.bodega = null
        },
        makeUser(state, data) {
            localStorage.setItem('userid', data.id);
            localStorage.setItem('username', data.username);
            localStorage.setItem('usergroup', data.auth);
            localStorage.setItem('bodega', data.bodega);
            localStorage.setItem('lang', data.lang);
            state.userid = data.id
            state.username = data.username
            state.usergroup = data.auth
            state.bodega = data.bodega
            state.lang = data.lang
        },
        setLang(state, data) {
            localStorage.setItem('lang', data);
            state.lang = data
        }
    },
    getters: {
        isLoggedIn: state => {
            if (state.userid && state.jwt) {
                return true
            }
            return false
        },
        isAdmin: state => {
            if (state.userid && state.jwt && state.usergroup == "staff") {
                return true
            }
            return false
        },

    },
    actions: {

        removeToken(context) {
            this.commit('removeToken');
        },
        async obtainToken(context, data) {
            const payload = {
                username: data.username,
                password: data.password
            }
            await axios.post(this.state.endpoints.obtainJWT, payload)
                .then((response) => {
                    if (response.data.token) {
                        this.commit('updateToken', response.data.token);
                    } else {
                        this.commit('removeToken');
                    }
                })
                .catch((error) => {
                    this.commit('removeToken');
                })
            console.log()
        },
        async getUser(context) {
            const jwt = this.state.jwt
            const config = {
                headers: {Authorization: "Bearer " + jwt}
            };
            await axios.get(this.state.endpoints.getUser, config)
                .then((response) => {
                    let data = response.data
                    if(response.data.bodega == "false"){
                        data.bodega = 0
                    }

                    this.commit('makeUser',data );
                })
                .catch((error) => {
                    this.commit('removeToken');
                })
        },
        async refreshToken() {
            const payload = {
                token: this.state.jwt
            }
            console.log("refreshing")
            console.log(payload)
            await axios.post(this.state.endpoints.refreshJWT, payload)
                .then((response) => {
                    this.commit('updateToken', response.data.token)
                })
                .catch((error) => {
                    this.commit('removeToken');
                })
        },
        inspectToken() {
            if (this.state.jwt) {
                const decoded = jwt_decode(this.state.jwt);
                const exp = decoded.exp
                const refresh_exp = decoded.refresh_exp
                if ((exp - (Date.now() / 1000)) < 600) { // last 10 min
                    this.commit('updateToken', "")
                } else if ((refresh_exp - (Date.now() / 1000)) < 3600) {
                    this.dispatch('refreshToken')
                }
            }
        }
    }
})
